import React from 'react';
import logo from '../assets/logo.png';
import ModernFooter from './modern/ModernFooter';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
export default function Footer() {
  return <ModernFooter logo={<img src={logo} className="h-8 w-8" alt="" />} />;
}
